module.exports = __webpack_public_path__ + "static/media/rabbit.6bd5e726.svg";